import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const ScreenSecurityStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }

    .description {
      margin: 30px auto 0;
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      &-icon {
        margin: 0 0 16px;
      }
    }

    .animation {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .securityPolicy {
      text-align: center;
      width: 100%;
      max-width: 330px;
      position: absolute;
      margin: 0;
      top: 50%;
      left: 50%;
      transform: translate(-50%, 0);
      right: 0;
    }

    .disclaimer {
      text-align: center;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 0);
      width: 100%;
      max-width: 330px;
      padding: 0 10px;
    }

    .link {
      height: unset !important;
      padding: unset;
      border: unset;
      --background: unset !important;
      font-size: 0.9em !important;
      min-height: 0.9em;
      text-decoration: underline;

      &::part(native) {
        color: rgba(128, 62, 255);
        --ripple-color: rgba(128, 62, 255);
        --ripple-color: transparent;
        --padding-bottom: 0.7em;
        --padding-end: 0.1em;
        --padding-start: 0.3em;
        --padding-top: 0.1em;

        &::after {
          content: none;
        }
      }
    }

    .terms-checkbox-label {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      margin-top: 8px;
      text-align: left;
      cursor: pointer;

      .terms-checkbox {
        appearance: none;
        -webkit-appearance: none;
        width: 18px;
        height: 18px;
        border: 2px solid rgba(128, 62, 255);
        border-radius: 4px;
        background: transparent;
        cursor: pointer;
        position: relative;
        margin: 0;
        flex-shrink: 0;

        &:checked {
          background: rgba(128, 62, 255);

          &::after {
            content: '';
            position: absolute;
            left: 50%;
            top: 50%;
            width: 4px;
            height: 8px;
            border: solid #fff;
            border-width: 0 2px 2px 0;
            transform: translate(-50%, -60%) rotate(45deg);
          }
        }
      }

      span {
        line-height: 1.4;

        .terms-link {
          color: rgba(128, 62, 255);
          text-decoration: underline;
        }
      }
    }
  }
`;
